import { render, staticRenderFns } from "./ClientsSectionTabs.vue?vue&type=template&id=4111b939&scoped=true"
import script from "./ClientsSectionTabs.vue?vue&type=script&lang=js"
export * from "./ClientsSectionTabs.vue?vue&type=script&lang=js"
import style0 from "./ClientsSectionTabs.vue?vue&type=style&index=0&id=4111b939&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4111b939",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabs})
